import http from "../http-common";
/* eslint-disable */
class PsikologisDiscService {
  getList(page, itemPerPage, keyword, type) {
    return http.get(
      "/psikologis-pertanyaan/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&alat_test_id=" +
        type,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("pertanyaan", data.pertanyaan);
    bodyFormData.append("urutan", data.urutan);
    bodyFormData.append("alat_test_id", data.alat_test_id);
    bodyFormData.append("psikologis_category_id", data.selectedCategory.id);

    return http.post("/psikologis-pertanyaan", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("pertanyaan", data.pertanyaan);
    bodyFormData.append("urutan", data.urutan);
    bodyFormData.append("alat_test_id", data.alat_test_id);
    bodyFormData.append("psikologis_category_id", data.selectedCategory.id);

    return http.put(`/psikologis-pertanyaan/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/psikologis-pertanyaan/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new PsikologisDiscService();
